import { DatePicker } from '@mantine/dates';
import classNames from './date-picker.module.css';
export const datePickerProps = DatePicker.extend({
    classNames,
});
